export default "__VITE_ASSET__DqbDOLwl__"